export const getVoiceWorkflowCompletionState = (record = {}) => {
  if (
    record.workflowCompleted === true ||
    record.workflowStatus === "confirmed" ||
    (record.action === "workflowCompleted" && Boolean(record.rsvpStatus))
  ) return "completed";
  if (
    record.workflowCompleted === false ||
    record.action === "callFailed" ||
    ["busy", "failed", "no-answer", "canceled"].includes(record.callStatus) ||
    (record.callStatus === "completed" && ["pending", "collecting"].includes(record.workflowStatus))
  ) return "incomplete";
  return "unknown";
};

export const isVoiceRsvpRecorded = (record = {}) =>
  record.responseRecorded === true ||
  (record.action === "workflowCompleted" && Boolean(record.rsvpStatus));
